import React from 'react'
import { PropertyImages } from '../../../../types/Property/Property'
import { HeroIcons } from '../../../../lib/utils/heroIcons'

type ImagesSectionProps = {
  images: PropertyImages[]
  onImageClick: (index: number) => void
  isMobile: boolean
}

export default function ImagesSection({
  images,
  onImageClick,
  isMobile,
}: ImagesSectionProps) {
  return (
    <div className="relative grid grid-cols-2 gap-x-3 overflow-visible pb-2">
      <div className="relative col-span-2 aspect-[16/9] md:col-span-1 md:aspect-auto">
        <img
          src={images[0]?.url}
          alt="property image"
          className="h-full w-full cursor-pointer rounded-l-2xl rounded-r-2xl border-b border-l border-t border-neutralGray/50 object-cover object-center md:rounded-r-none"
          onClick={() => (images[0]?.url ? onImageClick(1) : null)}
        />
        <HeroIcons.HomeIcon className="absolute left-1/2 top-1/2 -z-10 w-12 -translate-x-1/2 -translate-y-1/2 transform text-gray-400/50" />
      </div>
      <div className="hidden grid-cols-2 gap-3 md:grid">
        <div className="aspect-h-2 aspect-w-3 relative overflow-hidden bg-gray-100/10 text-xs">
          <img
            src={images[1]?.url}
            alt="property image"
            className="h-full w-full cursor-pointer border-t border-neutralGray/50 object-cover object-center"
            onClick={() => (images[1]?.url ? onImageClick(2) : null)}
            loading={isMobile ? 'lazy' : 'eager'}
          />

          <HeroIcons.HomeIcon className="absolute left-1/2 top-1/2 -z-10 w-12 -translate-x-1/2 -translate-y-1/2 transform text-gray-400/50" />
        </div>

        <div className="aspect-h-2 aspect-w-3 relative overflow-hidden bg-gray-100/10 text-xs">
          <img
            src={images[2]?.url}
            alt="property image"
            className="h-full w-full cursor-pointer rounded-tr-2xl border-r border-t border-neutralGray/50 object-cover object-center"
            onClick={() => (images[2]?.url ? onImageClick(3) : null)}
            loading={isMobile ? 'lazy' : 'eager'}
          />
          <HeroIcons.HomeIcon className="absolute left-1/2 top-1/2 -z-10 w-12 -translate-x-1/2 -translate-y-1/2 transform text-gray-400/50" />
        </div>

        <div className="aspect-h-2 aspect-w-3 relative bg-gray-100/10 text-xs">
          <img
            src={images[3]?.url}
            alt="property image"
            className="h-full w-full cursor-pointer border-b border-neutralGray/50 object-cover object-center"
            onClick={() => (images[3]?.url ? onImageClick(4) : null)}
            loading={isMobile ? 'lazy' : 'eager'}
          />
          <HeroIcons.HomeIcon className="absolute left-1/2 top-1/2 -z-10 w-12 -translate-x-1/2 -translate-y-1/2 transform text-gray-400/50" />
        </div>

        <div className="aspect-h-2 aspect-w-3 relative bg-gray-100/10 text-xs">
          <img
            src={images[4]?.url}
            alt="property image"
            className="h-full w-full cursor-pointer rounded-br-2xl border-b border-r border-neutralGray/50 object-cover object-center"
            onClick={() => (images[4]?.url ? onImageClick(5) : null)}
            loading={isMobile ? 'lazy' : 'eager'}
          />
          <HeroIcons.HomeIcon className="absolute left-1/2 top-1/2 -z-10 w-12 -translate-x-1/2 -translate-y-1/2 transform text-gray-400/50" />
        </div>
      </div>
    </div>
  )
}
